import { render, staticRenderFns } from "./Actions.vue?vue&type=template&id=04508cbf&scoped=true"
import script from "./Actions.vue?vue&type=script&lang=ts"
export * from "./Actions.vue?vue&type=script&lang=ts"
import style0 from "./Actions.vue?vue&type=style&index=0&id=04508cbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04508cbf",
  null
  
)

export default component.exports